import React from 'react';
// eslint-disable-next-line no-unused-vars
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ChatBot as AiChatBot } from '@amzn/aws-tc-ai-coaching-frontend';
import { isNil } from 'ramda';

import { showChatBotOnLabPage } from './utils';
import { useEventContext } from '../../contexts';
import { getBlueprintName } from '../../utils/blueprintUtils';
import { dataTestId } from '../../constants/dataTestIdSelectors';

const ChatBot = ({ blueprintArn, gandalfToken }) => {
  const { event } = useEventContext();

  if (isNil(blueprintArn) || isNil(gandalfToken)) return null;
  if (
    !showChatBotOnLabPage({
      eventContext: event,
      blueprintName: getBlueprintName(blueprintArn),
    })
  ) {
    return null;
  }

  return (
    <span data-testid={dataTestId['ai-chatbot']}>
      <AiChatBot blueprintArn={blueprintArn} gandalfToken={gandalfToken} />
    </span>
  );
};

ChatBot.propTypes = {
  blueprintArn: PropTypes.string.isRequired,
  gandalfToken: PropTypes.string.isRequired,
};

export default ChatBot;
